import React, { FC } from 'react';

import { ReactTable } from '@nhl/nhl-breakaway-ui';
import { ColumnDef } from '@tanstack/react-table';

import useTableScroll from '~/core/hooks/useTableScroll';
import { LeftShadowForStickyColumns } from '~/core/table/styles';

import { Goalie, GoalieSeasonStat, Skater, SkaterSeasonStat } from '../../types';

import { SIZING, TeamRosterTableContainer } from './styles';

type Props = {
    initialSort: { id: string; desc: boolean }[];
    data: Array<SkaterSeasonStat | Skater | GoalieSeasonStat | Goalie>;
    columns: Array<ColumnDef<SkaterSeasonStat | Skater | GoalieSeasonStat | Goalie>>;
};

export const LeftShadowTable: FC<Props> = ({ initialSort, data, columns }) => {
    const { tableChild, onTableMounted, tableScroll } = useTableScroll();

    const rect = tableChild?.getBoundingClientRect();
    const height = rect?.height || 0;
    const top = tableChild?.offsetTop || 0;

    return (
        <TeamRosterTableContainer ref={onTableMounted}>
            <ReactTable columns={columns} data={data} initialSorting={initialSort} />
            <LeftShadowForStickyColumns
                $scrollPosition={tableScroll}
                $shadowHeight={height}
                $toTop={top}
                $leftPosition={SIZING.sweaterNumber.small + SIZING.playerName.small}
                $leftPositionAboveMedium={SIZING.sweaterNumber.large + SIZING.playerName.large}
            />
        </TeamRosterTableContainer>
    );
};
